import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AuthPage.css';

/**
 * PRD-037 Task 2.2: Forgot Password Page
 * Allows users to request a password reset email
 */
const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Email is required.');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setIsLoading(true);

    try {
      // Intentionally not using response - we always show success to prevent email enumeration
      await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.toLowerCase().trim() })
      });

      // Always show success to prevent email enumeration
      // The backend also returns success regardless of whether email exists
      setSubmitted(true);
    } catch (err) {
      // Even on error, show success to prevent enumeration
      setSubmitted(true);
    } finally {
      setIsLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="page-container auth-page" style={{
        maxWidth: '500px',
        margin: '0 auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh'
      }}>
        <div className="auth-form-container card-style" style={{ width: '100%' }}>
          <h2>Check Your Email</h2>
          <p style={{ color: '#00e6d2', marginBottom: '20px' }}>
            If an account with that email exists, we've sent a password reset link.
            Please check your inbox and spam folder.
          </p>
          <p style={{ color: '#b0b8c1', fontSize: '0.9rem', marginBottom: '20px' }}>
            The link will expire in 1 hour.
          </p>
          <Link to="/login" className="button" style={{ display: 'block', textAlign: 'center' }}>
            Return to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container auth-page" style={{
      maxWidth: '500px',
      margin: '0 auto',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh'
    }}>
      <div className="auth-form-container card-style" style={{ width: '100%' }}>
        <h2>Reset Your Password</h2>
        <p style={{ color: '#b0b8c1', marginBottom: '20px' }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              placeholder="Enter your email address"
              className={error ? 'error' : ''}
              required
              autoComplete="email"
              disabled={isLoading}
            />
            {error && <span className="error-text">{error}</span>}
          </div>
          <button type="submit" className="button" disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <p className="auth-switch-message">
          Remember your password? <Link to="/login">Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
